import { Button, Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { openMobileAppLink } from '../core';

const Item = ({ type, location, getIcon, dimensions = 20, navigate, isMobile, onClick, marg }) => {
  const selected =
    location === type.toLowerCase() ||
    (type.toLowerCase() === 'home' && location === '') ||
    (type.toLowerCase() === 'messages' && location.includes('messages'));
  const appState = useSelector((state) => state.appState);

  if (appState.hideBottomNav) return null;

  return (
    <Clickable marg={marg || 0} onClick={onClick || (() => navigate(`/${type.toLowerCase()}`))}>
      <Col centerAll wid="49px">
        <Row centerAll wid="24px" ht="24px">
          <Icon
            type={getIcon(type.toLowerCase(), selected)}
            col={selected ? '#000' : theme.GREY_50}
            dimensions={dimensions}
          />
        </Row>

        <Text c1 bold marg="4px 0 0" col={selected ? '#000' : theme.GREY_50}>
          {type}
        </Text>
      </Col>
    </Clickable>
  );
};

const Footer = (props) => {
  const [showAppLink, setShowAppLink] = useState(true),
    navigate = useNavigate(),
    location = useLocation().pathname.slice(1),
    { t } = useTranslation(),
    isAndroid = navigator.userAgent.match(/Android/i),
    appState = useSelector((state) => state.appState);

  if (appState.hideBottomNav) return null;

  function getIcon(label, selected) {
    return `${label}${selected ? 'Filled' : 'Outline'}`;
  }

  function handleClick() {
    openMobileAppLink(isAndroid !== null);
  }

  return (
    <Col wid="100%" bg="#fff" noFlex pos="fixed" zIndex={3} bottom="0">
      {showAppLink && (
        <Row
          bg="#fff"
          zIndex="3"
          wid="100vw"
          ht="94px"
          tabletHt="64px"
          bottom="0"
          left="0"
          style={{ boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.1)' }}
          centerAll
          enableMediaQuery
        >
          <Row center between wid="936px">
            <Row>
              <Text enableMediaQuery tabletSize="35px" bold marg={'5px 0px 0px 5px'}>
                {t('getTheApp.header')}
              </Text>
            </Row>

            <Row alignCenter>
              <Button
                text={t('auth.getTheApp')}
                onClick={handleClick}
                bg={theme.SECONDARY}
                small
                wid="120px"
                marg="5px"
                col="white"
              />

              <Clickable
                onClick={(e) => {
                  setShowAppLink(false);

                  if (!e) e = window.event;
                  e.cancelBubble = true;
                  if (e.stopPropagation) e.stopPropagation();
                }}
              >
                <Row
                  ht="40px"
                  wid="40px"
                  pos="absolute"
                  top={'10px'}
                  bottom={'0px'}
                  right={'-15px'}
                  enableMediaQuery
                  tabletPos="relative"
                >
                  <Icon dimensions={14} col={theme.GREY_60} type="close" />
                </Row>
              </Clickable>
            </Row>
          </Row>
        </Row>
      )}
      <Row borderTop={`1px solid ${theme.GREY_20}`} wid="100vw" pad="11px 0 7px" between>
        <Item
          type="Home"
          marg="0 0 0 16px"
          getIcon={getIcon}
          navigate={navigate}
          location={location}
        />

        <Item
          type="Browse"
          getIcon={getIcon}
          navigate={navigate}
          location={location}
          dimensions={22}
        />

        <Item
          type="Shoutout"
          getIcon={getIcon}
          navigate={navigate}
          location={location}
          dimensions={22}
        />

        <Item
          type="Store"
          getIcon={getIcon}
          navigate={navigate}
          location={location}
          dimensions={16}
        />

        <Item
          type="Profile"
          marg="0 16px 0 0"
          getIcon={getIcon}
          navigate={navigate}
          location={location}
        />
      </Row>
    </Col>
  );
};

export default Footer;
